import React from 'react';
import Orders from './Orders';

function OrdersConfirmed() {
  return <Orders status="confirmed" />;
}

export default OrdersConfirmed;
